<template>
    <div>
        <div>
            <breadcrumb :routerList="[{title:'采购项目'}]"/>
            <div class="h-content">
                <div class="h-row h-mrt0">
                    <div class="h-rowIn">
                        <div class="h-rowBox">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>基本信息</h1>
                                    </div>
                                    <div class="h-pieceCon2" style="padding:0">
                                        <div class="h-formLine initiate">
                                            <el-form :model="formLabelAlign" label-position="right" ref="cai"
                                                     :inline="true"
                                                     class="demo-ruleForm h-formbLine h-formbLine1">
                                                <el-form-item label="项目编号" class="h-elformWrap-2" prop="id">
                                                    <el-input readonly v-model="formLabelAlign.id"></el-input>
                                                </el-form-item>
                                                <el-form-item label="项目名称" class="h-elformWrap-2" prop="projectName">
                                                    <el-input readonly v-model="formLabelAlign.projectName"></el-input>
                                                </el-form-item>
                                                <el-form-item label="项目说明" class="h-elformWrap-1"
                                                              prop="projectDescription">
                                                    <el-input readonly v-model="formLabelAlign.projectDescription"
                                                              maxlength="70" placeholder="请输入">
                                                    </el-input>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                        <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                            <h1>产品信息</h1>
                                        </div>
                                        <el-table
                                                @selection-change="handleSelectionChange"
                                                ref="multipleTable"
                                                :data="proProductwx"
												border
                                                style="width: 100%">
                                            <el-table-column
                                                    type="selection"
                                                    :selectable="selectFlag"
                                                    width="50"
                                                    :label="all"
                                                    @header-click="headerClick"
                                            >
                                            </el-table-column>
                                            <el-table-column
                                                    type="index"
                                                    width="40"
                                                    label="#">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="typeName"
                                                    min-width="90"
                                                    label="产品大类">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="productName"
                                                    label="产品型号"
                                                    min-width="150"
                                                    :show-overflow-tooltip="true">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="xuniFlag"
                                                    label="产品类型">
                                                <template scope="scope">
                                                    {{scope.row.xuniFlag|dictname('xuni_flag')}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="productId"
                                                    label="产品编码"
                                                    min-width="150"
                                                    :show-overflow-tooltip="true">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="productDes"
                                                    label="产品描述"
                                                    min-width="150"
                                                    :show-overflow-tooltip="true">
                                            </el-table-column>
                                        </el-table>
                                        <div>
                                            <div class="h-txtCenter h-mrt60">
                                                <!--                                                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancelPro">取消-->
                                                <!--                                                </el-button>-->
                                                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="addForms">选择供应商
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br/>
                                <div class="N-chan">

                                    <div v-for="(item,index) in addForm"
                                         :key="index">
                                        <div class="h-pieceTitle2">
                                            <h1>询价分行信息</h1>
                                        </div>
                                        <el-table
                                                ref="multipleTable"
                                                :span-method="objectSpanMethod"
                                                :data="item"
												border
                                                style="width: 100%">
                                            <el-table-column
                                                    type="index"
                                                    width="40"
                                                    label="#">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="productName"
                                                    label="产品型号"
                                                    width="220">
                                            </el-table-column>
                                            <el-table-column
                                                    label="询价截止日期"
                                                    width="160"
                                                    :rules="[{ required: true, message: '请输入询价截止日期', trigger: 'blur'},]"
                                                    prop="timeOut">
                                                <template scope="scope">
                                                    <el-date-picker
                                                            v-model="addForm[index].timeOut"
                                                            type="date"
                                                            style="width:150px;"
                                                            :clearable="false"
                                                            value-format="yyyy-MM-dd"
                                                            placeholder="--选择--"
                                                            :picker-options="timeOPT">
                                                    </el-date-picker>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="supplierHistory"
                                                    label="已选择供应商"
                                                    width="230">
                                                <template scope="scope">
                                                    <el-select v-model="addForm[index].supplierHistory"
                                                               placeholder="--未选择--"
                                                               disabled
                                                               filterable
                                                               multiple
                                                               style="width:200px;"
                                                               size="large"
                                                               @change="changeSupplier">
                                                        <el-option
                                                                v-for="(item,index) in optionsSupplier"
                                                                :key="index"
                                                                :label="item.userName"
                                                                :value="item.usercode">
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="supplierId"
                                                    label="供应商名称">
                                                <template scope="scope">
                                                    <div style="display: flex;justify-content: flex-start;align-items: center;">
                                                        <el-checkbox v-model="scope.row.checked" @change="changecheck(scope.row)" style="margin-right: 0.3rem">全选</el-checkbox>
                                                        <el-select v-model="addForm[index].supplierId"
                                                                   placeholder="--请选择--"
                                                                   filterable
                                                                   multiple
                                                                   size="large"
                                                                   style="width: 100%;"
                                                                   :disabled="scope.row.checked"
                                                                   @change="changeSupplier">
                                                            <!--@change="selectAll"-->
                                                            <!--                                                    @change="changeSupplier(scope.row,scope.$index)"-->
                                                            <!--<el-option label='全选' value='全选'></el-option>-->
                                                            <el-option
                                                                    v-for="(item,index) in optionsSupplier"
                                                                    :key="index"
                                                                    :label="item.userName"
                                                                    :value="item.usercode">
                                                            </el-option>
                                                        </el-select>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    label="操作"
                                                    width="100"
                                                    fixed="right">
                                                <template slot-scope="scope">
                                                   <el-button
                                                            type="text"
                                                            size="small"
                                                            class="h-tableLink h-btn"
                                                            @click="deleteRow(index)">
                                                        删除
                                                    </el-button>
													<!-- <div class="l-operationBox">
														<span class="l-operationlist br-operation-delete" title="删除" @click="deleteRow(index)"></span>
													</div> -->
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <br/>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="h-txtCenter h-mrt60">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="cancelPro">返回</el-button>
                    <!-- <el-button class="h-btn h-bBtn h-bggreen" @click="zanCun">暂存</el-button> -->
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitNew">确认提交</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
                checked:false,
                all: '全部',
                timeOut: null,
                timeOPT: this.timePicker(),
                proProductwx: [],
                formLabelAlign: {},
                info: {},
                infoList: [],
                optionsSupplier: [],
                supplier: [{supplierId: ''}],
                norepeat: [],
                addForm: [],
                multipleSelection: [],
                spanArr: [],
                oldOptions: [],
                value5: [],
                rowNum: 0,
            }
        },
        created() {
            this.supplierOption();
            this.query();
        },
        methods: {
            changecheck(v){
                if (v.checked) {
                    for (var i = 0; i < this.addForm.length; i++) {
                        for (var j = 0; j < this.addForm[i].length; j++) {
                            if (v.id == this.addForm[i][j].id) {
                                this.addForm[i].supplierId = [];
                                this.addForm[i].supplierId.push('所有供应商');
                            }
                        }
                    }
                }
            },

            selectFlag(row, index) {
                return !row.isSelect;
            },
            //删除已选
            deleteRow(x) {
                if (this.addForm.length < 2) {
                    this.proProductwx.forEach((item, index) => {
                        item.isSelect = false;
                    })
                    this.addForm = [];
                } else {
                    this.addForm.forEach((item, index) => {
                        item.forEach((item2, index2) => {
                            item2.isSelect = false;
                        })
                    })
                    this.addForm.forEach((item, index) => {
                        if (x == index) {
                            this.addForm[index] = [];
                        }
                    })
                }
                this.addForm = _.filter(this.addForm, function (o) {
                    return o.length > 0;
                });

                this.addForm.forEach((item, index) => {
                    item.forEach((item2, index2) => {
                        item2.isSelect = true;
                    })
                })
                this.$refs.multipleTable.clearSelection();
            },
            //增加一个询价表
            addForms() {

                var arr = [];
                // var selectCopy = _.clone(this.multipleSelection);
                if (this.addForm.length < 1) {
                    if(this.multipleSelection.length < 1){
                        this.$msg.msge("请先选择产品!");
                        return;
                    }
                    arr = this.multipleSelection;
                    this.addForm.push(arr);
                } else {
                    this.addForm.forEach((item, index) => {
                        arr = _.pullAll(this.multipleSelection, this.addForm[index]);
                    })
                    if (arr.length > 0) {
                        this.addForm.push(arr);
                    }
                }

                this.addForm.forEach((item, index) => {
                    item.forEach((item2, index2) => {
                        item2.isSelect = true;
                    })
                })

                // console.log('我在这儿呀', this.addForm);
                this.info.proProductInfoList = arr;
                this.infoList.push(this.info);

                this.$refs.multipleTable.clearSelection();
            },
            //选择按钮
            headerClick() {

            },

            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (column.label == '询价截止日期' || column.label == '供应商名称'
                    || column.label == '已选择供应商' || column.label == '操作') {
                    return {
                        rowspan: 100,
                        colspan: 1,
                    }
                }
            },
            //日期选择
            timePicker() {
                return {
                    disabledDate(time) {
                        return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
                    }
                }
            },
            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            query() {
                ss.ProService.proDetail(this.$route.query.id).then(rd => {
                    this.formLabelAlign = rd;
                    // console.log('我在这儿呀项目详情', this.formLabelAlign);
                    this.info = _.clone(this.formLabelAlign);
                    this.info.proProductInfoList = [];

                    //产品信息赋值
                    this.proProductwx = rd.proProductInfoList;
                    var allgroup = {};
                    for (var i = 0; i < this.proProductwx.length; i++) {
                        if (this.proProductwx[i].groupId) {
                            if (allgroup[this.proProductwx[i].groupId]) {
                                // allgroup['checked'] = false;
                                allgroup[this.proProductwx[i].groupId].push(this.proProductwx[i])
                                allgroup[this.proProductwx[i].groupId].supplierHistory = this.proProductwx[i].offerIds;
                            } else {
                                // allgroup['checked'] = false;
                                allgroup[this.proProductwx[i].groupId] = [];
                                allgroup[this.proProductwx[i].groupId].push(this.proProductwx[i])
                                allgroup[this.proProductwx[i].groupId].supplierHistory = this.proProductwx[i].offerIds;
                            }
                        }
                    }
                    // console.log('我在这儿呀334', allgroup);
                    _.forEach(allgroup, (item, index) => {
                        // console.log('我在这儿呀335', item);
                        this.addForm.push(item);
                        
                        // //去掉已选择过的供应商
                        // item.forEach((item2, index2) => {
                        //     console.log('我在这儿呀336', item2);
                        //     item2.offerIds.forEach((item3, index3) => {
                        //         console.log('我在这儿呀337', item3);
                        //         _.reject(this.optionsSupplier, ['usercode', item3])
                        //     })
                        // })
                    })
               
                });
            },
            supplierOption() {
                ss.ProService.supplierSearchList({}).then(rd => {
                    // console.log(rd, "optionsSupplier");
                    this.optionsSupplier = rd;
                })
            },
            changeSupplier() {
                // console.log('我在这儿呀,haha', this.addForm);
            },
            adds() {
                var a = {supplierId: ''}
                this.supplier.push(a)
                // console.log(this.supplier);
            },
            cancelPro() {
                this.$router.push("/xiangmu/pm");
            },
            submitNew() {
                if (this.supplier.length > 0) {
                    var productList = [];

                    for (var i = 0; i < this.addForm.length; i++) {
                        var item = this.addForm[i];
                        if(!item.timeOut && item.supplierId){
                            this.$msg.msge("请填写询价截止日期！");
                            return;
                        }
                        for (var j = 0; j < item.length; j++) {
                            var item2 = item[j];
                            item2.supplierId = _.join(item.supplierId, ",");
                            item2.timeOut = item.timeOut;
                            if (!item2.supplierId) {
                                this.$msg.msge("请完善信息后再提交！");
                                return;
                            }
                            item2.mark = i;
                            productList.push(item2);
                        }
                    }

                    this.formLabelAlign.maxMark = this.addForm.length;
                    this.formLabelAlign.proPriceOfferList = this.supplier;
                    // console.log('提交后台内容', this.formLabelAlign);
                    this.$msg.confirm("确认发起询价?", () => {
                        ss.ProService.saveInquiry(this.formLabelAlign).then(rd => {
                            this.$msg.msgs("发起成功！");
                            this.$router.push("/xiangmu/pm");
                        })
                    })
                } else {
                    this.$msg.msge("请选择供应商！");
                }
            },
            zanCun() {

            },
            delIndex(index) {
                this.supplier.splice(index, 1);
                this.norepeat.splice(index, 1);
            },
        }
    }

</script>


<style>
    .initiate .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .initiate .h-formbLine .el-form-item__content {
        width: 69%;
    }

    .initiate .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .initiate .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .initiate .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
    }

    .initiate .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 90.3%;
    }
</style>